import { render, staticRenderFns } from "./CouponFavourites.vue?vue&type=template&id=1b3aae78&"
import script from "./CouponFavourites.vue?vue&type=script&lang=js&"
export * from "./CouponFavourites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports